import { useAppSelector } from "hooks/redux";
import React, { useCallback, useEffect, useRef, useState } from "react";
import WS from "utils/ws";
import {
    setQuotes,
    setAvailableTickers,
    setSelectedTickers,
    setAllTickers,
} from "store/reducers/quotes";
import { useDispatch } from "react-redux";
import { _updateWorkspaces, setSrtSChedule } from "store/reducers/TabsSlice";
import { useLocation } from "react-router-dom";
import { useTimer } from "use-timer";
import Error from "utils/Notifications/Error";
import { store } from "store/store";
import { showModal } from "store/reducers/modal";

import { notification } from "antd";

const WSHandler = () => {
    const selectedRobotId = useAppSelector(
        (state) => state.robots.selectedRobotId,
    );
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const onTimeOver = () => {
        Error("Данные с сервера не поступают");

        if (isFirstLoad) setIsFirstLoad(false);
    };

    const { start, reset } = useTimer({
        onTimeOver,
        endTime: isFirstLoad ? 20 : 5,
    });
    const dispatch = useDispatch();

    const page_name = useAppSelector(
        (state) =>
            state.quotesPage.activePage && state.quotesPage.activePage.name,
    );

    const active_page_id = useAppSelector(
        (state) => state.quotes.active_page_id,
    );

    const quotes_info = useAppSelector((state) => state.quotes.info);

    const qi = useRef(quotes_info);
    qi.current = quotes_info;

    const _id = useRef(active_page_id);
    _id.current = active_page_id;
    const { pathname } = useLocation();
    const resetRef = useRef(reset);
    resetRef.current = reset;

    const updateFn = useCallback(
        (event: any) => {
            if (!event || !event.data) return;

            resetRef.current();
            const data = JSON.parse(event.data); 

            if (data.type === "ui_block") {
                const { mode, event_type, message, group_name, created_at } =
                    data;
                const displayText = `${message || "Ошибка"} (${
                    group_name || "Без группы"
                }, ${created_at || "Время не указано"})`;

                if (mode === "full") {
                    dispatch(
                        showModal({
                            modal_type: "ui_block_full",
                            value: true,
                            caller: active_page_id,
                            args: { message: displayText, event_type },
                        }),
                    );
                } else if (mode === "partial") {
                    notification.error({
                        message: "UI Block",
                        description: displayText,
                        placement: "topRight",
                        duration: 5000,
                    });
                }
                return;
            }

            if (data.type === "srt_shedule") {
                dispatch(setSrtSChedule(data.schedule));
                return;
            }

            const quotes_data = [];
            const selected_tickers = [];
            let available_tickers: string[] = [];

            const decline_checks = [
                {
                    reason: "updating with non active workspaces",
                    fn: (data: any[]) => {
                        const part = data[0];
                        const obs = qi.current[active_page_id];
                        if (obs) {
                            const check = obs.find((x: any) => x === part?.id);
                            if (!check) return true;
                        }
                    },
                },
            ];

            for (const check of decline_checks) {
                if (check.fn(data)) return;
            }

            for (const dat of data) {
                if (typeof dat === "undefined") continue;
// console.log(data);

                dispatch(setAllTickers(dat.available_tickers || []));

                const state = store.getState();
                const existing = state.quotes.quotes[dat.id];
                const statuses = existing?.statuses || dat.statuses || [];

                quotes_data.push({
                    id: dat.id,
                    columns: dat.columns,
                    params: dat.params,
                    statuses,
                    error_flags:dat.error_flags ,
                    close_values: dat.close_values,
                });

                selected_tickers.push({
                    id: dat.id,
                    data: dat.selected_tickers,
                });

                if (
                    Array.isArray(dat.available_tickers) &&
                    dat.available_tickers.length > 0
                ) {
                    const names = dat.available_tickers
                        .map((item: any) => item.Name)
                        .filter(Boolean);

                    available_tickers = Array.from(
                        new Set([...available_tickers, ...names]),
                    );
                }
            }

            dispatch(
                setQuotes({ data: quotes_data, reference: active_page_id }),
            );
            dispatch(
                _updateWorkspaces({
                    data: quotes_data,
                    reference: active_page_id,
                }),
            );

            if (
                Array.isArray(available_tickers) &&
                available_tickers.length > 0
            ) {
                dispatch(setAvailableTickers(available_tickers));
            }
            if (Array.isArray(selected_tickers) && selected_tickers.length) {
                dispatch(setSelectedTickers(selected_tickers));
            }
        },
        [active_page_id, dispatch],
    );

    useEffect(() => {
        if (
            !active_page_id ||
            !pathname.includes("quotes") ||
            !selectedRobotId
        ) {
            WS.closeTab(active_page_id);
            return;
        }

        start();

        WS.connect({
            tab_id: active_page_id,
            onUpdate: updateFn,
            name: page_name,
            robotId: selectedRobotId,
        });

        return () => {
            WS.closeTab(active_page_id);
        };
    }, [active_page_id, page_name, pathname, selectedRobotId, updateFn]);
    return <></>;
};

export default WSHandler;
